// extracted by mini-css-extract-plugin
export var orderDetails = "_oq-2";
export var orderImage = "_oq-1";
export var orderMeta = "_oq-3";
export var orderSummary = "_oq-0";
export var rightArrow = "_oq-4";